import React, { Dispatch, FC, SetStateAction, memo, useEffect, useRef, useState } from 'react'
import { inRange } from "lodash"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { FilterData, InventoryData, ToggleViewState } from 'pages/forecast/forecastTypes'
import { Paginator } from 'primereact/paginator'
import { Dialog } from 'primereact/dialog'
import HoverTable from './HoverTable'
import { generateExcel, userPreferencesType } from 'utils/generateInventoryExcel'
import { capitalizeHeader, findObjectWithMaxKeys } from 'utils/helper'

interface DataTablePropsType {

	data?: InventoryData
	first: number
	setFirst: Dispatch<SetStateAction<number>>
	setFilter: Dispatch<SetStateAction<FilterData>>
	filterData: FilterData
	downloadCsv: boolean
	setDownloadCsv: Dispatch<SetStateAction<boolean>>;
	currentUIView: ToggleViewState
}








const excelHeaders = ["product_id", "product_name", "category", "total_sales_quantity", "total_forecasted_inventory", "history"]



const DataTableComponent: FC<DataTablePropsType> = memo(({
	data, first, setFirst, setFilter, filterData,
	downloadCsv, setDownloadCsv, currentUIView }) => {

	const [showHoverTable, setShowHoverTable] = useState(false)
	const rowIndexRef = useRef<number | null>(null);
	const rowDataRef = useRef()

	const userPreferences: userPreferencesType = {
		Forecast_by: filterData.forecast_by,
		Start_date: filterData.forecast_range_start_date,
		End_date: filterData.forecast_range_end_date,
	}


	const filteredResult: any | [] = data?.result.map(item => {
		const { history, ...rest } = item;
		return rest;
	});

	const historyData: any | [] = data?.result.map(item => {
		const { history } = item;
		return history;
	});

	const forecastData: any | [] = data?.result.map(item => {
		const { history, product_id, product_name, category, total_forecasted_inventory, total_sales_quantity, ...rest } = item;
		return rest;
	});


	const maxObject = findObjectWithMaxKeys(filteredResult)


	const excelData: any[] | undefined = data?.result.map((item: any) => {


		const tempObject: any = {}

		for (const key in item) {
			if (item.hasOwnProperty(key)) {

				if (excelHeaders.includes(key)) {
					tempObject[key] = item[key];
				}
				else {

					if (!tempObject.forecast) {
						tempObject.forecast = {};
					}
					tempObject.forecast[key] = item[key];
				}

			}
		}
		return tempObject

	})

	useEffect(() => {

		if (downloadCsv && currentUIView.gridView) {

			generateExcel(userPreferences, excelData)
			// exportPdf()
			setDownloadCsv(false)

		}

	}, [downloadCsv])


	const clickColumnTemplate = (rowData: any, options: { rowIndex: number }) => {


		// const salesQtyKey = Object.keys(rowData).find(key => key.includes('sales_qty'));


		return (
			<span onClick={() => {
				setShowHoverTable(true)
				rowIndexRef.current = options.rowIndex
				rowDataRef.current = rowData
			}} style={{ cursor: "pointer", textDecoration: "underline" }}>
				{rowData['total_sales_quantity'!]}
			</span>
		);
	};


	return (<>
		<Dialog visible={showHoverTable} className='hover-table' onHide={() => { if (!showHoverTable) return; setShowHoverTable(false); }}>
			<HoverTable historyData={historyData[rowIndexRef.current!]} rowData={rowDataRef.current} />
		</Dialog>


		<div className="user-management-section">
			{data?.result && data?.result.length > 0 ?
				<DataTable
					value={data?.result ?? []}

					scrollable
					className='inventoryForecast'
					scrollHeight="500px"
				>
					{data?.result && Object.keys(maxObject ?? {}).map((col, index) => {

						// const salesHeader = col.includes('sales_qty') && col
						if (col === 'total_sales_quantity') return <Column key={col} frozen={inRange(index, 0, 5)} field={col} header={capitalizeHeader(col)}
							body={clickColumnTemplate} />
						return <Column key={col} frozen={inRange(index, 0, 5)} field={col} header={capitalizeHeader(col)} />
					}

					)}
				</DataTable>
				:
				<div className="custom-empty-message">No records available for this selection</div>
			}
			{data?.result.length! > 0 && <Paginator
				first={first}
				rows={filterData.size_limit}
				totalRecords={data?.total_count ?? 10}
				onPageChange={(e: any) => {
					setFirst(e.first)
					setFilter((prev: any) => {
						return { ...prev, size_limit: e.rows, page: e.page + 1 }
					})

				}}
				className="p-paginator-bottom"
				rowsPerPageOptions={[25, 50, 100]}
			/>}

		</div>
	</>
	)
}
)
export default DataTableComponent
